var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FX_title_box"},[_c('div',{staticStyle:{"margin-left":"1rem","position":"relative"}},[_c('div',{staticClass:"title_box1"},[_vm._v("  青創資源中心&中原育成 線上服務系統 ")]),_c('div',{staticClass:"title_box2"},[_vm._v(" 線上服務系統"),_c('br'),_c('span',{staticStyle:{"font-size":"0.6rem"}},[_vm._v("  中原育成")])])])])
}]

export { render, staticRenderFns }